<div class="generic-card" (click)="onCardClick()" [class.loading]="isLoading" (keydown.enter)="onCardClick()">
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="spinner"></div>
  </div>
  <div *ngIf="showEditButton" class="edit-button-container">
    <button class="icon-button" (click)="onEditClick($event)" aria-label="Edit item">
      <img src="assets/images/virtusa-icons/edit-light.svg" class="edit-icon" alt="Edit" />
    </button>
  </div>
  <div class="card-body">
    <p class="card-description">{{ cardData.title }}</p>
    <p class="card-description">{{ cardData.description }}</p>
  </div>

  <div class="card-footer" *ngIf="cardData.time">
    <img src="assets/images/virtusa-icons/edit-light.svg" class="edit-icon" alt="Edit" />
    <span class="edit-text">{{ formatEditedTime(cardData.time) }}</span>
  </div>

  <div class="card-footer" *ngIf="cardData.type">
    <img [src]="getImage(cardData.type)" alt="Icon" />
  </div>
</div>
